import { useEffect, useRef } from 'react';
import Image from 'next/image';
import { useGSAP } from '@gsap/react';
import gsap from "gsap";
import useSectionsStore from "../../stores/SectionsStore.jsx";


// interface HomeHeroProps {
//   image: { url: string };
//   title: string;
//   text: string;
// }

const HomeHero = ({image, text, title}) => {


  const heroSection = useRef(null)
  const polygonBlock = useRef(null)

  const setSectionRef = useSectionsStore((state) => state.setSectionRef)


    useEffect(()=> {
        if (heroSection.current) {
            setSectionRef('homeHeroSection' ,heroSection)
        }
    }, [heroSection.current])


  useGSAP(()=> {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

    gsap.fromTo(polygonBlock.current, {
          clipPath: "polygon(50% 0%, 0% 0, 50% 50%, 50% 100%, 100% 100%, 50% 50%)"
    }, {
        clipPath: "polygon(50% 0%,50% 0%,50% 50%,50% 100%,50% 100%,50% 50%)",
        ease: "none",
          scrollTrigger: {
            trigger: heroSection.current,
            start: "top top",
            end: "10% top",
            scrub: 0.8,
          },
    })

  })
  }, {scope: heroSection});

  return (
    <section ref={heroSection} className="container-max w-full relative lg:h-[160vh]">
      <div className='flex overflow-x-hidden  flex-col lg:min-h-[100svh] lg:sticky  top-[5.6rem] md:top-[7.2rem] lg:top-[7.4rem] xl:top-[8.4rem] w-full'>
        <div className="overflow-hidden w-full relative  h-[25.1rem] md:h-[40rem]    lg:h-auto lg:aspect-[3.5] xl:aspect-[3.36]">
          <Image
            src={image?.url}
            alt={image?.alt}
            fill
            fetchPriority="high"
            priority={true}
            sizes="100vw"
            className="w-auto object-cover"
          />
          <div ref={polygonBlock} className='bg-beige initialPolygonHero hidden lg:block right-[39.2%] scale-[1.005] top-0 translate-x-1/2 absolute z-10 h-[180%] aspect-[1.5] '></div>
        </div>

        <div className='w-full container-grid flex-col pt-[2rem] pb-[4rem] md:pt-[2.4rem] md:pb-[6rem] lg:pt-[4rem] lg:pb-[7rem] xl:pb-[12rem] xl:pt-[5.6rem] container-padding'>
            <h1 className="md:max-w-[72rem] lg:max-w-none [&>.selected]:italic md:col-span-5  lg:col-span-6 [&>.selected]:text-dusty-green-dark mb-[1.6rem] md:mb-[2.4rem] lg:mb-0 text-dark-blue" dangerouslySetInnerHTML={{__html: title}}/>
            <div className='flex lg:pl-[16%] flex-col md:col-span-3 lg:col-start-10 gap-[1.6rem]'>
              {text?.map((item, index)=> (<p key={index} className="text-1 md:col-span-3 text-dark-blue">{item.text}</p>))}
          </div>
        </div>
      </div>




    </section>
  );
};

export default HomeHero;